import { Icon } from '@/components/ui/icon';
import { ProductMetaRow } from './ProductMetaRow';

export interface WishlistProductPreviewProps {
  image?: string;
  brand?: string;
  name?: string;
  color?: string;
  size?: string;
  quantity?: number;
}

/**
 * Compact product preview rendered at the top of the Add-to-Wishlist sheet.
 * 50x72 thumbnail + brand + name + meta row. Heart-solid icon on the right.
 */
export function WishlistProductPreview({
  image,
  brand,
  name,
  color,
  size,
  quantity,
}: WishlistProductPreviewProps) {
  return (
    <div className="flex items-center gap-4 px-4">
      <div className="bg-jncquoi-neutral-50 relative h-[72px] w-[50px] shrink-0 overflow-hidden">
        {image && (
          <img
            src={image}
            alt={name ?? brand ?? ''}
            className="absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
        )}
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <div className="flex flex-col gap-2">
          {brand && (
            <span className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[10px] leading-tight font-semibold tracking-[0.5px] uppercase">
              {brand}
            </span>
          )}
          {name && (
            <span className="font-pp-neue-montreal text-jncquoi-neutral-1000 line-clamp-2 text-[12px] leading-snug font-normal tracking-[0.5px]">
              {name}
            </span>
          )}
        </div>
        <ProductMetaRow color={color} size={size} quantity={quantity} />
      </div>

      <Icon
        name="heart-solid"
        width={24}
        height={24}
        className="text-jncquoi-neutral-1000 shrink-0"
        aria-hidden="true"
      />
    </div>
  );
}
